import {forwardRef} from 'react';
import {Icon, IconifyIcon} from '@iconify/react';

import Box, {BoxProps} from '@mui/material/Box';

import {IconifyProps} from './types';

import iconMap from '../../utils/iconifyLocalMap';
// ----------------------------------------------------------------------

interface Props extends BoxProps {
  icon: IconifyProps;
}

const Iconify = forwardRef<SVGElement, Props>(
  ({icon, width = 20, sx, ...other}, ref) => {
    const resolvedIcon = (iconMap as Record<string, IconifyIcon>)[icon as string] || icon;
    return (
      <Box
        ref={ref}
        component={Icon}
        className="component-iconify"
        icon={resolvedIcon}
        sx={{width, height: width, ...sx}}
        {...other}
      />
    );
  }
);

export default Iconify;
